<template>
  <div ref="attendeesList">
    <div class="md-layout md-layout-item md-size-100">
      <md-field class="md-form-group md-layout-item md-size-100">
        <label>{{ $t('Search') }}</label>
        <md-input v-model="filters.search" v-on:keyup.enter="loadData(true)" />
      </md-field>

      <md-field class="md-form-group md-layout-item md-size-30 md-small-size-100">
        <label for="f_trade" style="margin-right:10px">{{$t('Trade')}}</label>
        <md-select v-model="filters.trade" name="f_thematicPath" md-dense>
          <md-option>{{$t('Show all')}}</md-option>
          <md-option v-for="v in lookups.trades" :key="v.value" :value="v.value">{{v.text}}</md-option>
        </md-select>
      </md-field>

      <div class="md-layout-item md-size-5 md-small-hide" />
      <md-field class="md-form-group md-layout-item md-size-30 md-small-size-100">
        <label for="f_role">{{$t('Role')}}</label>
        <md-select v-model="filters.role" name="f_role" md-dense>
          <md-option>{{$t('Show all')}}</md-option>
          <md-option
            v-for="v in [1, 0, 6, 4, 5, 2, 3]"
            :key="v"
            :value="v"
          >{{$t(`attendeerole.${v}`)}}</md-option>
        </md-select>
      </md-field>

      <div class="md-layout-item md-size-5 md-small-hide" />
      <md-field class="md-form-group md-layout-item md-size-30 md-small-size-100">
        <label for="f_country">{{$t('Country')}}</label>
        <md-select v-model="filters.country" name="f_country" md-dense>
          <md-option>{{$t('Show all')}}</md-option>
          <md-option v-for="v in lookups.countries" :key="v" :value="v">{{v}}</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout md-layout-item md-size-100">
      <div class="ml-auto">
        <md-button
          @click="loadData(true);"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:0px"
        >{{$t('Search')}}</md-button>
      </div>
    </div>

    <template v-if="loaded">
      <template v-if="items.length">
        <item v-for="item in items" :key="item.id" :item="item" showDetailsLink="true" />
        <scroll-loader :loader-method="loadData" :loader-disable="!loadMore">
          <div>{{$t('Loading')}}...</div>
        </scroll-loader>
      </template>
      <no-data v-else />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";
import Item from "./AttendeesListItem";
import NoData from "@/pages/authenticated/NoData";

export default {
  components: { Item, NoData },
  data() {
    return {
      filters: {},
      lookups: {},
      loaded: false,
      loadMore: true,
      take: 100,
      items: []
    };
  },

  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current"
    }),
    skip() {
      return this.items.length;
    }
  },
  methods: {
    async loadLookups() {
      let loader = this.$loading.show({ container: this.$refs.attendeesList });
      try {
        this.lookups = (
          await axios.get("public/attendees/lookups", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code
            }
          })
        ).data;
      } finally {
        this.loaded = true;
        loader.hide();
      }
    },
    async loadData(resetItems, reloadLookups) {
      let loader = this.$loading.show({ container: this.$refs.attendeesList });

      try {
        if (reloadLookups) {
          await this.loadLookups();
        }

        if (resetItems) {
          this.items = [];
        }

        var parsedFilters = { ...this.filters };

        parsedFilters.trade = !!parsedFilters.trade
          ? parsedFilters.trade
          : null;
        parsedFilters.country = !!parsedFilters.country
          ? parsedFilters.country
          : null;
        parsedFilters.role =
          !!parsedFilters.role || parsedFilters.role === 0
            ? parsedFilters.role
            : null;

        let subItems = (
          await axios.get("public/attendees/list", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code,
              ...parsedFilters,
              skip: this.skip,
              take: this.take
            }
          })
        ).data;

        this.loadMore = subItems.length == this.take;
        this.items = this.items.concat(subItems);
      } finally {
        this.loaded = true;
        loader.hide();
      }
    }
  },
  watch: {
    async conference() {
      this.loaded = false;
      this.items = [];
      await this.loadData(true, true);
    },
    async language() {
      this.loaded = false;
      this.items = [];
      await this.loadData(true, true);
    }
  },
  async mounted() {
    await this.loadData(true, true);
  }
};
</script>
<style lang="scss" scoped>
.info {
  .icon > i {
    font-size: 2.5rem !important;
  }
  .info-title {
    margin: 1rem;
  }
}
</style>